import React, { useState } from 'react';
import { Loader2, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useLanguage } from '../../context/LanguageContext';
import { SignaturePad } from '../utt/SignaturePad';

const Field = ({ label, children }) => (
  <label className="block space-y-1 text-sm"><span className="text-xs font-medium text-muted-foreground">{label}</span>{children}</label>
);

export const FaidaSignupForm = ({ initial, reason, onSubmit }) => {
  const { t } = useLanguage();
  const [f, setF] = useState({ full_name: initial?.full_name || '', phone: initial?.phone || '', email: initial?.email || '',
    nida: '', desired_amount_tzs: initial?.desired_amount_tzs || 50000 });
  const [consent, setConsent] = useState(false);
  const [signature, setSignature] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onSubmit({ ...f, desired_amount_tzs: Number(f.desired_amount_tzs), signature, consent });
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="space-y-4 rounded-2xl border border-border bg-card p-5" data-testid="faida-signup-form">
      {reason && <p className="rounded-lg bg-amber-50 p-3 text-sm text-amber-800" data-testid="faida-needs-info-reason">{t('WHI needs more information:', 'WHI wanahitaji taarifa zaidi:')} {reason}</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label={t('Full name (as on NIDA)', 'Jina kamili (kama kwenye NIDA)')}><Input value={f.full_name} onChange={set('full_name')} required data-testid="faida-input-name" /></Field>
        <Field label={t('Mobile number', 'Namba ya simu')}><Input value={f.phone} onChange={set('phone')} placeholder="07XX XXX XXX" required data-testid="faida-input-phone" /></Field>
        <Field label={t('Email', 'Barua pepe')}><Input type="email" value={f.email} onChange={set('email')} required data-testid="faida-input-email" /></Field>
        <Field label={t('NIDA number (20 digits)', 'Namba ya NIDA (tarakimu 20)')}><Input value={f.nida} onChange={set('nida')} required data-testid="faida-input-nida" /></Field>
        <Field label={t('First deposit (min TZS 10,000)', 'Amana ya kwanza (chini TZS 10,000)')}><Input type="number" min={10000} step={1000} value={f.desired_amount_tzs} onChange={set('desired_amount_tzs')} required data-testid="faida-input-amount" /></Field>
      </div>
      <SignaturePad onChange={setSignature} />
      <label className="flex items-start gap-2 text-xs text-muted-foreground">
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" data-testid="faida-consent" />
        {t('I agree that Wekeza-Smart shares these details with Watumishi Housing Investments (WHI) to open my Faida Fund account.',
          'Nakubali Wekeza-Smart itume taarifa hizi kwa Watumishi Housing Investments (WHI) ili kunifungulia akaunti ya Faida Fund.')}
      </label>
      <Button type="submit" disabled={busy || !consent || !signature} className="w-full sm:w-auto" data-testid="faida-signup-submit">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ShieldCheck className="mr-2 h-4 w-4" />}
        {reason ? t('Resubmit to WHI', 'Tuma tena kwa WHI') : t('Send to WHI', 'Tuma kwa WHI')}
      </Button>
    </form>
  );
};
